module.exports = __webpack_public_path__ + "img/审查@2x.9ef557e5.png";